
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 468.293 468.293"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M209.097 62.543c0-6.548-5.308-11.856-11.856-11.856H53.75c-6.548 0-11.856 5.308-11.856 11.856v4.586a9.602 9.602 0 01-9.602 9.602c-6.548 0-11.856 5.308-11.856 11.856v111.109h414.93V76.73H223.285c-7.836 0-14.188-6.352-14.188-14.187z","fill":"#3ea69b"}}),_c('path',{attrs:{"fill":"#ebf0f3","d":"M46.742 99.753h377.569v194.498H46.742z"}}),_c('path',{attrs:{"d":"M444.582 417.606H23.711C10.616 417.606 0 406.99 0 393.895v-251.99c0-13.095 10.616-23.711 23.711-23.711h254.614a23.71 23.71 0 0022.058-15.014l11.532-29.25a23.71 23.71 0 0122.058-15.014H444.58c13.095 0 23.711 10.616 23.711 23.711v311.268c.002 13.095-10.614 23.711-23.709 23.711z","fill":"#44c4a1"}})])
          )
        }
      }
    